import { render, staticRenderFns } from "./continuityvip.vue?vue&type=template&id=38c86312&scoped=true&"
import script from "./continuityvip.vue?vue&type=script&lang=js&"
export * from "./continuityvip.vue?vue&type=script&lang=js&"
import style0 from "./continuityvip.vue?vue&type=style&index=0&id=38c86312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c86312",
  null
  
)

export default component.exports